import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-migration',
  templateUrl: './cloud-migration.component.html',
  styleUrls: ['./cloud-migration.component.css']
})
export class CloudMigrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
